import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
  ActionsButtonsWrapper,
  ControllersWrapper,
  ViewWrapper,
} from '@components/form/style';
import ReadOnlyFormField from '@components/form/ReadOnlyFormRow';
import * as accountInfoConstants from '@features/account-settings/constants';
import { Button } from '@amzn/storm-ui';
import { FORM_CHANGE_BUTTON_TRANSLATION_KEY } from 'src/pages/accountSettings/constants';
import useIntl from '@i18n/useIntl';
import { toggleAccountNameEditMode } from 'src/shared/state/account-settings-slice';

const AccountNameViewer = () => {
  const dispatch = useDispatch();
  const { intl } = useIntl();
  const { getValues } = useFormContext();

  return (
    <ViewWrapper>
      <ControllersWrapper>
        <ReadOnlyFormField
          label={intl.getMessage(
            accountInfoConstants.ACCOUNT_DISPLAY_NAME_FIELD_EDIT_LABEL,
          )}
          id={accountInfoConstants.ACCOUNT_NAME_FIELD_ID}
          value={getValues(
            accountInfoConstants.ACCOUNT_NAME_FIELD_CONTROLLER_NAME,
          )}
        />
      </ControllersWrapper>
      <ActionsButtonsWrapper>
        <Button onClick={() => dispatch(toggleAccountNameEditMode())}>
          {intl.getMessage(FORM_CHANGE_BUTTON_TRANSLATION_KEY)}
        </Button>
      </ActionsButtonsWrapper>
    </ViewWrapper>
  );
};

export default AccountNameViewer;
